
<template>
  <div class="appDashboard dashboard2">
    <div :class="{container:appConfig.container}">
      <app-header :title="title"></app-header>
    </div>
    <v-layout class="flex md12 ml-1" :class="{container:appConfig.container}" row wrap>
      <app-card class="md12 sm12 xs12 d-flex" :obj="{title}">
        <div slot="body">
          <v-layout style="position: absolute; left: 50px;">
            <v-btn
              depressed
              color="primary"
              :class="{disabled: isAutoUpdate}"
              v-on:click="onClickAutoUpdate"
            >
              {{ $t('CurrentStatus.AutoUpdate')}}
              <span v-if="isAutoUpdate">({{countDownTimer}})</span>
            </v-btn>
            <v-btn
              depressed
              color="primary"
              :disabled="!isAutoUpdate"
              v-on:click="onClickStopUpdate"
            >{{ $t('CurrentStatus.StopUpdate')}}</v-btn>

            <v-btn
              depressed
              color="primary"
              :class="{disabled: isAutoUpdate}"
              v-on:click="onClickUpdate"
            >{{ $t('CurrentStatus.ManualUpdate')}}</v-btn>
          </v-layout>
          <v-layout>
            <span v-if="onOffStatus == 'ON-LINE'" class="onStatus">{{onOffStatus}}</span>
            <span v-if="onOffStatus == 'OFF-LINE'" class="offStatus">{{onOffStatus}}</span>
          </v-layout>
          <v-layout style="position: absolute; right: 50px;">
            <v-btn depressed class="v-btn v-btn--depressed theme--light info" v-on:click="onClickTop">{{ $t('CurrentStatus.GoToTop')}}</v-btn>
            <v-btn depressed class="v-btn v-btn--depressed theme--light info" v-on:click="onClickUp">{{ $t('CurrentStatus.GoToUp')}}</v-btn>
          </v-layout>

          <object
            id="svg-fig"
            :data="svgUrl"
            type="image/svg+xml"
            width="100%"
            height="100%"
            style="margin-top: 50px;"
          ></object>
        </div>
      </app-card>
    </v-layout>
  </div>
</template>

<script>
import mediator from "../../components/common/mediator.vue";
import moment from "moment";
import locale from "../../utility/Locale";

export default {
  name: "RackStatus",
  mixins: [mediator],

  mounted() {
    $(".appCard__header").remove();
    this.title = this.$root.currentPageName;

    this.setSvgUrl();
    setTimeout(() => {
      this.viewSVG();
      // デフォルトで自動更新
      this.onClickAutoUpdate();
    }, this.$root.svgWaitingTime);
  },
  beforeDestroy() {
    clearInterval(this.$root.currentTimer);
  },
  data() {
    const $t = this.$t.bind(this);

    return {
      title: $t("RackStatus.Item"),
      $fig: null,
      isAutoUpdate: false,
      countDownTimer: 10,
      svgUrl: "",
      x_array: [],
      rack_switch_array_1: [],
      rack_switch_array_2: [],
      onOffStatus: '',
      isBankFirstRequest: true,
      isRackFirstRequest: true
    };
  },
  methods: {
    onClickUpdate() {
      this.isAutoUpdate = false;
      this.countDownTimer = 10;
      this.viewSVG();
    },
    onClickAutoUpdate() {
      this.isAutoUpdate = true;

      this.$root.currentTimer = setInterval(() => {
        if (!this.isAutoUpdate) {
          clearInterval(this.$root.currentTimer);
        }

        if (this.countDownTimer === 0) {
          this.viewSVG();
          this.countDownTimer = 10;
        } else {
          this.countDownTimer--;
        }
      }, 1000);
    },
    onClickStopUpdate() {
      this.isAutoUpdate = false;
      this.countDownTimer = 10;
    },
    onClickTop() {
      this.$router.push({ name: "top_page" });
    },
    onClickUp() {
      this.$router.push({ name: "bank_status" });
    },
    setSvgUrl() {
      if (process.env.NODE_ENV === "development") {
        if (locale.getCurrentLanguage() === "ja") {
          this.svgUrl = "/static/svg/rack_jp.svg";
        } else {
          this.svgUrl = "/static/svg/rack_cn.svg";
        }
      } else {
        if (locale.getCurrentLanguage() === "ja") {
          this.svgUrl = "static/svg/rack_jp.svg";
        } else {
          this.svgUrl = "static/svg/rack_cn.svg";
        }
      }
    },
    viewSVG() {
      let vm = this;
      this.$fig = $(document.getElementById("svg-fig").contentDocument);

      // Bank共通
      vm.axios
        .get(`${vm.$root.url}/Customer/BankStatus4Rack`, {
          headers: {
            Authorization: `Bearer ${vm.$root.token}`
          },
          params: {
            assign: vm.$root.assign,
            systemSn: vm.$root.currentSerial.system,
            bankSn: vm.$root.currentSerial.bank
          }
        })
        .then(response => {
          let data = response.data;
          if(this.isBankFirstRequest){
            this.isBankFirstRequest = false;
            this.modifyBankSVG(data);
          }
          this.onOffStatus = data[0].onOffStatus;
          this.setBankBase(data[0]);

          vm.loading = false;
        })
        .catch(error => {
          vm.error = true;
          vm.result = "Error";
          vm.showResult = true;
        });

      // Rack個別
      vm.axios
        .get(`${vm.$root.url}/Customer/RackStatus`, {
          headers: {
            Authorization: `Bearer ${vm.$root.token}`
          },
          params: {
            assign: vm.$root.assign,
            bankSn: vm.$root.currentSerial.bank
          }
        })
        .then(response => {
          // 初期化
          let $element_ini = vm.$fig.find('.st31');
          $element_ini.css('display','none');

          let data = response.data;
          if(this.isRackFirstRequest){
            this.isRackFirstRequest = false;
            this.modifyRackSVG(data);
          }
          this.setRackVisible(data);
          this.setRackBase(data);
          this.setSwitch(data);
          this.setMaxMin(data);
          this.setRackImage(data);
          this.setRachErrorCode(data);
          this.setAnimationPCS(data);
          this.setAnimationRack(data);

          vm.loading = false;
        })
        .catch(error => {
          vm.error = true;
          vm.result = "Error";
          vm.showResult = true;
        });
    },
    modifyBankSVG(data) {
      if(data[0].showSoe){
        this.$fig.find(`.bankSoeVisibility`).css('visibility', 'visible');
        this.$fig.find(`.verticalBarX555-555Y40-160`).css('visibility', 'hidden');
        this.$fig.find(`.verticalBarX555-555Y40-185`).css('visibility', 'visible');
      }
    },
    setBankBase(data) {
      //base 初期非表示のものを表示
      let $base_var = this.$fig.find('#base-var');
      $base_var.css('display','inherit');

      let $base_txt_title = this.$fig.find('#base-txt-title');
      $base_txt_title.text(data.systemNm);

      let $base_data_bankno = this.$fig.find('#base-data-bankno');
      $base_data_bankno.text(data.bankNo);

      let $base_data_bankserial = this.$fig.find('#base-data-bankserial');
      $base_data_bankserial.text(data.bankSn);

      let $base_data_nominal = this.$fig.find('#base-data-nominal');
      $base_data_nominal.text(`${data.capacity} Ah`);

      let $base_data_surplus = this.$fig.find('#base-data-surplus');
      $base_data_surplus.text(`${Math.round(data.capacity * (data.soh/100) * (data.soc/100))} Ah`);

      let $base_data_time = this.$fig.find('#base-data-time');
      $base_data_time.text(data.serverTime);

      let $base_data_sw = this.$fig.find('#base-data-sw');
      $base_data_sw.text(data.version);

      let $base_data_voltage = this.$fig.find('#base-data-voltage');
      $base_data_voltage.text(data.totalVolt + ' V');

      let $base_data_current = this.$fig.find('#base-data-current');
      $base_data_current.text(data.totalCurrent + ' A');

      let $base_data_current_02 = this.$fig.find('#base-data-current-02');
      $base_data_current_02.text(data.totalCurrent + ' A');

      let $base_data_soc = this.$fig.find('#base-data-soc');
      $base_data_soc.text(data.soc + ' %');

      let $base_data_soe = this.$fig.find('#base-data-soe');
      $base_data_soe.text(data.soh + ' %');

      let $base_data_cell_high = this.$fig.find('#base-data-cell-high');
      $base_data_cell_high.text(data.maxCellVolt + ' V');

      let $base_data_cell_low = this.$fig.find('#base-data-cell-low');
      $base_data_cell_low.text(data.minCellVolt + ' V');

      let $base_data_cell_high_rack = this.$fig.find('#base-data-cell-high-rack');
      $base_data_cell_high_rack.text(`RACK ${data.maxVoltRack}`);

      let $base_data_cell_low_rack = this.$fig.find('#base-data-cell-low-rack');
      $base_data_cell_low_rack.text(`RACK ${data.minVoltRack}`);

      let $base_data_temp_high = this.$fig.find('#base-data-temp-high');
      $base_data_temp_high.text(data.maxTemperature + ' ℃');

      let $base_data_temp_low = this.$fig.find('#base-data-temp-low');
      $base_data_temp_low.text(data.minTemperature + ' ℃');

      let $base_data_temp_high_rack = this.$fig.find('#base-data-temp-high-rack');
      $base_data_temp_high_rack.text(`RACK ${data.maxTemperatureRack}`);

      let $base_data_temp_low_rack = this.$fig.find('#base-data-temp-low-rack');
      $base_data_temp_low_rack.text(`RACK ${data.minTemperatureRack}`);

      let $base_txt_pcs = this.$fig.find('#base-txt-pcs');
      $base_txt_pcs.text(`PCS-${data.bankNo}`);

      let $errorcode = this.$fig.find('#base-data-errorcode');
      $errorcode.text(`0x${data.bankErrorCode}`);

      const alarm = Array.from(data.alarm).reverse();
      alarm.map((error, index) => {
        let $error_f_val = null;
        let $error_txt = null;
        switch (index) {
          case 0: // OVP
            $error_f_val = this.$fig.find('#base-bg-ovp-f');
            $error_txt = this.$fig.find('#base-txt-ovp');
            break;
          case 1: // UVP
            $error_f_val = this.$fig.find('#base-bg-uvp-f');
            $error_txt = this.$fig.find('#base-txt-uvp');
            break;
          case 2: // OCP
            $error_f_val = this.$fig.find('#base-bg-ocp-f');
            $error_txt = this.$fig.find('#base-txt-ocp');
            break;
          case 3: // UCP
            $error_f_val = this.$fig.find('#base-bg-ucp-f');
            $error_txt = this.$fig.find('#base-txt-ucp');
            break;
          case 4: // OTP
            $error_f_val = this.$fig.find('#base-bg-otp-f');
            $error_txt = this.$fig.find('#base-txt-otp');
            break;
          case 5: // UTP
            $error_f_val = this.$fig.find('#base-bg-utp-f');
            $error_txt = this.$fig.find('#base-txt-utp');
            break;
        }

        if (error === "1") {
          if ($error_f_val) {
            $error_f_val.css('display', 'inherit');
            $error_f_val.css('fill', '#ff3121');
            $error_txt.css('fill', '#ffffff');
          }
        } else {
          if ($error_f_val) {
            $error_f_val.css('display', 'none');
            $error_txt.css('fill', '#727272');
          }
        }
      });
    },
    modifyRackSVG(data){
      // TDS ONLY
      if(data[0].showSoe){
        this.$fig.find(`.rackSoeVisibility`).css('visibility', 'visible');
        this.$fig.find(`.rack-status-frame-threeLine`).css('visibility', 'hidden');
        this.$fig.find(`.rack-status-frame-fourLine`).css('visibility', 'visible');
        this.$fig.find(`#rack-status-Line-4th`).css('visibility', 'visible');
      }
    },
    setRackVisible(data) {
      // 初期化
      this.x_array.length = 0;
      this.rack_switch_array_1.length = 0;
      this.rack_switch_array_2.length = 0;
      var rackCount = data[0].rackCount;
      for (var i = 0; i < rackCount; i++) {
        let $rack = this.$fig.find(`#rack-${data[i].rackNo}`);
        $rack.data('rackSn', data[i].rackSn);

        let screenwdth = 1710;
        let $onoff_val = this.$fig.find(`#rack-${data[i].rackNo}`);
        if (i <= rackCount) {
          $onoff_val.css('display', 'inline');
        } else {
          $onoff_val.css('display', 'none');
        }

        // 後で使用するためこの場所で配列にセット
        let pos = ((screenwdth / rackCount) * i);
        this.x_array.push(pos);
        this.rack_switch_array_1.push(data[i].chargeIHS);
        this.rack_switch_array_2.push(data[i].switchOnOff);

        $onoff_val.attr('transform', 'translate(' + pos + ',0)');
        $onoff_val.off('click');
        if ((this.$root.userRole).at(-1) > 2) {
          // NiMHを含むRACKの場合はクリック後のリンク先を変える
          if (data[i].nimhFg == 1) {
            $onoff_val.on('click', (event) => {
              this.$root.currentSerial.rack = $(event.currentTarget).data("rackSn");
              this.$router.push({ name: "nimh_status" });
            });
          } else {
            $onoff_val.on('click', (event) => {
              this.$root.currentSerial.rack = $(event.currentTarget).data("rackSn");
              this.$router.push({ name: "pack_status" });
            });
          }
        }
      }

      if ((this.$root.userRole).at(-1) < 3) {
        // Do not use the finger pointer
        this.$fig.find(`.st30`).css('cursor', 'default');
      };
    },

    setRackBase(data) {
      data.map(rack => {
        let $rackname_val = this.$fig.find(`#rack-txt-name-${rack.rackNo}`);
        if (rack.rackNo != undefined && rack.rackNo != null) {
          $rackname_val.text(`RACK_${rack.rackNo}`);
        }

        let $rackno_a_val = this.$fig.find(`#rack-txt-no-${rack.rackNo}a`);
        if (rack.rackSn != undefined && rack.rackSn != null) {
          $rackno_a_val.text(rack.rackSn.substr(0, 8));
        }

        let $rackno_b_val = this.$fig.find(`#rack-txt-no-${rack.rackNo}b`);
        if (rack.rackSn != undefined && rack.rackSn != null) {
          $rackno_b_val.text(rack.rackSn.substr(8));
        }

        let $totalCurrent = this.$fig.find(`#rack-data-current-${rack.rackNo}`);
        if (rack.totalCurrent != undefined && rack.totalCurrent != null) {
          $totalCurrent.text(`${rack.totalCurrent}A`);
        }

        let $totalVolt = this.$fig.find(`#rack-data-volt-${rack.rackNo}`);
        if (rack.totalVolt != undefined && rack.totalVolt != null) {
          $totalVolt.text(`${rack.totalVolt}V`);
        }

        let $soc = this.$fig.find(`#rack-data-soc-${rack.rackNo}`);
        if (rack.soc != undefined && rack.soc != null) {
          $soc.text(`${rack.soc}%`);
        }

        let $soe = this.$fig.find(`#rack-data-soe-${rack.rackNo}`);
        if (rack.soh != undefined && rack.soh != null) {
          $soe.text(`${rack.soh}%`);
        }

        let $d2 = this.$fig.find(`#rack-data-d2-${rack.rackNo}`);
        if (rack.d2 != undefined && rack.d2 != null && rack.d2 == 1 ) {
          $d2.text(`調整可`);
        }

        let $capacity = this.$fig.find(`#rack-data-left-${rack.rackNo}`);
        if(rack.capacity != undefined && rack.capacity != null) {
          $capacity.text(`${Math.round(rack.capacity * (rack.soh/100) * (rack.soc/100))}Ah`);
        }

        let $maxCellVolt = this.$fig.find(`#rack-data-cell-high-${rack.rackNo}`);
        if (rack.maxCellVolt != undefined && rack.maxCellVolt != null) {
          $maxCellVolt.text(`${rack.maxCellVolt}V`);
        }

        let $minCellVolt = this.$fig.find(`#rack-data-cell-low-${rack.rackNo}`);
        if (rack.minCellVolt != undefined && rack.minCellVolt != null) {
          $minCellVolt.text(`${rack.minCellVolt}V`);
        }

        let $maxVoltPack = this.$fig.find(`#rack-data-cell-high-cell-${rack.rackNo}`);
        if (rack.maxVoltPack != undefined && rack.maxVoltPack != null) {
          $maxVoltPack.text(`Pack ${rack.maxVoltPack}`);
        }

        let $minVoltPack = this.$fig.find(`#rack-data-cell-low-cell-${rack.rackNo}`);
        if (rack.minVoltPack != undefined && rack.minVoltPack != null) {
          $minVoltPack.text(`Pack ${rack.minVoltPack}`);
        }

        let $maxTemperature = this.$fig.find(`#rack-data-temp-high-${rack.rackNo}`);
        if (rack.maxTemperature != undefined && rack.maxTemperature != null) {
          $maxTemperature.text(`${rack.maxTemperature}℃`);
        }

        let $minTemperature = this.$fig.find(`#rack-data-temp-low-${rack.rackNo}`);
        if (rack.minTemperature != undefined && rack.minTemperature != null) {
          $minTemperature.text(`${rack.minTemperature}℃`);
        }

        let $maxTemperaturePack = this.$fig.find(`#rack-data-temp-high-cell-${rack.rackNo}`);
        if (rack.maxTemperaturePack != undefined && rack.maxTemperaturePack != null) {
          $maxTemperaturePack.text(`Pack ${rack.maxTemperaturePack}`);
        }

        let $minTemperaturePack = this.$fig.find(`#rack-data-temp-low-cell-${rack.rackNo}`);
        if (rack.minTemperaturePack != undefined && rack.minTemperaturePack != null) {
          $minTemperaturePack.text(`Pack ${rack.minTemperaturePack}`);
        }
        });
    },

    setSwitch(data) {
      data.map(rack => {
        let $switch_plus = this.$fig.find(`#rack-ihs-plus-${rack.rackNo}`);
        let $switch_neutral = this.$fig.find(`#rack-ihs-neutral-${rack.rackNo}`);
        let $switch_minus = this.$fig.find(`#rack-ihs-minus-${rack.rackNo}`);
        let $ihs_off = this.$fig.find(`#rack-ihs-off-${rack.rackNo}`);
        let $main_off = this.$fig.find(`#rack-main-off-${rack.rackNo}`);

        if (rack.switchOnOff == 1) {
          if(rack.chargeIHS == 1){
            if (rack.totalCurrent > 0 && rack.ihsUvp != 1) {
              $switch_plus.css('display', 'inherit');
              $switch_neutral.css('display', 'none');
              $switch_minus.css('display', 'none');
              $ihs_off.css('display', 'none');
              $main_off.css('display','none');
            } else if (rack.totalCurrent < 0 && rack.ihsOvp != 1) {
              $switch_plus.css('display', 'none');
              $switch_neutral.css('display', 'none');
              $switch_minus.css('display', 'inherit');
              $ihs_off.css('display', 'none');
              $main_off.css('display','none');
            } else {
              $switch_plus.css('display', 'none');
              $switch_neutral.css('display', 'inherit');
              $switch_minus.css('display', 'none');
              $ihs_off.css('display', 'none');
              $main_off.css('display','none');
            }
          } else {
            $switch_plus.css('display', 'none');
            $switch_neutral.css('display', 'none');
            $switch_minus.css('display', 'none');
            $ihs_off.css('display', 'inherit');
            $main_off.css('display','none');
          }
        } else {
          $switch_plus.css('display','none');
          $switch_neutral.css('display','none');
          $switch_minus.css('display','none');
          $ihs_off.css('display','none');
          $main_off.css('display','inherit');
        }

        if(rack.chargeIHS == 1){
          this.$fig.find(`#rack-switch-in-off-${rack.rackNo}`).children('line').attr('x2', '215');
          this.$fig.find(`#rack-switch-out-off-${rack.rackNo}`).children('line').attr('x2', '165');
          this.$fig.find(`#rack-switch-out-on-${rack.rackNo}`).children('line').attr('x2', '165');
          if(rack.ihsOvp == 1){
            this.$fig.find(`#rack-switch-in-off-${rack.rackNo}`).children('line').attr('x2', '235');
          }
          if(rack.ihsUvp == 1){
            this.$fig.find(`#rack-switch-out-off-${rack.rackNo}`).children('line').attr('x2', '185');
            this.$fig.find(`#rack-switch-out-on-${rack.rackNo}`).children('line').attr('x2', '185');
            this.$fig.find(`#rack-switch-out-on-${rack.rackNo}`).children('line').attr('y2', '382.64');
          }
        }else{
          this.$fig.find(`#rack-switch-in-off-${rack.rackNo}`).children('line').attr('x2', '235');
          this.$fig.find(`#rack-switch-out-off-${rack.rackNo}`).children('line').attr('x2', '185');
          this.$fig.find(`#rack-switch-out-on-${rack.rackNo}`).children('line').attr('x2', '185');
          this.$fig.find(`#rack-switch-out-on-${rack.rackNo}`).children('line').attr('y2', '382.64');
        }

      });
    },

    setMaxMin(data) {
      var RackCntVl = data[0].rackCount;
      let volt_maxmin = [];
      let left_maxmin = [];
      let soc_maxmin = [];
      let soh_maxmin = [];
      let cell_high_maxmin = [];
      let cell_low_maxmin = [];
      let temp_high_maxmin = [];
      let temp_low_maxmin = [];

      data.map(rack => {
        volt_maxmin.push(rack.totalVolt);
        left_maxmin.push(Math.round(rack.capacity * (rack.soh/100) * (rack.soc/100)));
        soc_maxmin.push(rack.soc);
        soh_maxmin.push(rack.soh);
        cell_high_maxmin.push(rack.maxCellVolt);
        cell_low_maxmin.push(rack.minCellVolt);
        temp_high_maxmin.push(rack.maxTemperature);
        temp_low_maxmin.push(rack.minTemperature);
      });

      let volt_max_val = Math.max.apply(null, volt_maxmin.slice(0, RackCntVl));
      let volt_min_val = Math.min.apply(null, volt_maxmin.slice(0, RackCntVl));
      let left_max_val = Math.max.apply(null, left_maxmin.slice(0,RackCntVl));
      let left_min_val = Math.min.apply(null, left_maxmin.slice(0,RackCntVl));
      let soc_max_val = Math.max.apply(null, soc_maxmin.slice(0, RackCntVl));
      let soc_min_val = Math.min.apply(null, soc_maxmin.slice(0, RackCntVl));
      let soh_max_val = Math.max.apply(null, soh_maxmin.slice(0, RackCntVl));
      let soh_min_val = Math.min.apply(null, soh_maxmin.slice(0, RackCntVl));
      let cell_high_max_val = Math.max.apply(null, cell_high_maxmin.slice(0, RackCntVl));
      let cell_high_min_val = Math.min.apply(null, cell_high_maxmin.slice(0, RackCntVl));
      let cell_low_max_val = Math.max.apply(null, cell_low_maxmin.slice(0, RackCntVl));
      let cell_low_min_val = Math.min.apply(null, cell_low_maxmin.slice(0, RackCntVl));
      let temp_high_max_val = Math.max.apply(null, temp_high_maxmin.slice(0, RackCntVl));
      let temp_high_min_val = Math.min.apply(null, temp_high_maxmin.slice(0, RackCntVl));
      let temp_low_max_val = Math.max.apply(null, temp_low_maxmin.slice(0, RackCntVl));
      let temp_low_min_val = Math.min.apply(null, temp_low_maxmin.slice(0, RackCntVl));

      data.map(rack => {
        let $svg_volt = this.$fig.find(`#rack-maxmin-volt-${rack.rackNo}`);
        if (volt_max_val != volt_min_val) {
          if (rack.totalVolt == volt_max_val) {
            $svg_volt.css('display', 'inherit');
            $svg_volt.css('fill', '#378bd1');
          } else if (rack.totalVolt == volt_min_val) {
            $svg_volt.css('display', 'inherit');
            $svg_volt.css('fill', '#99536e');
          }else{
            $svg_volt.css('display','none');
          }
        }

        let $svg_left = this.$fig.find(`#rack-maxmin-left-${rack.rackNo}`);
        if(left_max_val != left_min_val){
          let left_val = Math.round(rack.capacity * (rack.soh/100) * (rack.soc/100));
          if(left_val == left_max_val){
            $svg_left.css('display','inherit');
            $svg_left.css('fill','#378bd1');
          }else if(left_val == left_min_val){
            $svg_left.css('display','inherit');
            $svg_left.css('fill','#99536e');
          }else{
            $svg_left.css('display','none');
          }
        }

        let $svg_soc = this.$fig.find(`#rack-maxmin-soc-${rack.rackNo}`);
        if (soc_max_val != soc_min_val) {
          if (rack.soc == soc_max_val) {
            $svg_soc.css('display', 'inherit');
            $svg_soc.css('fill', '#378bd1');
          } else if (rack.soc == soc_min_val) {
            $svg_soc.css('display', 'inherit');
            $svg_soc.css('fill', '#99536e');
          }else{
            $svg_soc.css('display','none');
          }
        }

        let $svg_soh = this.$fig.find(`#rack-maxmin-soh-${rack.rackNo}`);
        if (soh_max_val != soh_min_val) {
          if (rack.soh == soh_max_val) {
            $svg_soh.css('display', 'inherit');
            $svg_soh.css('fill', '#378bd1');
          } else if (rack.soh == soh_min_val) {
            $svg_soh.css('display', 'inherit');
            $svg_soh.css('fill', '#99536e');
          }else{
            $svg_soh.css('display','none');
          }
        }

        let $svg_cell_high = this.$fig.find(`#rack-maxmin-cell-high-${rack.rackNo}`);
        if (cell_high_max_val != cell_high_min_val) {
          if (rack.maxCellVolt == cell_high_max_val) {
            $svg_cell_high.css('display', 'inherit');
            $svg_cell_high.css('fill', '#378bd1');
          } else if (rack.maxCellVolt == cell_high_min_val) {
            $svg_cell_high.css('display', 'inherit');
            $svg_cell_high.css('fill', '#99536e');
          }else{
            $svg_cell_high.css('display','none');
          }
        }

        let $svg_cell_low = this.$fig.find(`#rack-maxmin-cell-low-${rack.rackNo}`);
        if (cell_low_max_val != cell_low_min_val) {
          if (rack.minCellVolt == cell_low_max_val) {
            $svg_cell_low.css('display', 'inherit');
            $svg_cell_low.css('fill', '#378bd1');
          } else if (rack.minCellVolt == cell_low_min_val) {
            $svg_cell_low.css('display', 'inherit');
            $svg_cell_low.css('fill', '#99536e');
          }else{
            $svg_cell_low.css('display','none');
          }
        }

        let $svg_temp_high = this.$fig.find(`#rack-maxmin-temp-high-${rack.rackNo}`);
        if (temp_high_max_val != temp_high_min_val) {
          if (rack.maxTemperature == temp_high_max_val) {
            $svg_temp_high.css('display', 'inherit');
            $svg_temp_high.css('fill', '#378bd1');
          } else if (rack.maxTemperature == temp_high_min_val) {
            $svg_temp_high.css('display', 'inherit');
            $svg_temp_high.css('fill', '#99536e');
          }else{
            $svg_temp_high.css('display','none');
          }
        }

        let $svg_temp_low = this.$fig.find(`#rack-maxmin-temp-low-${rack.rackNo}`);
        if (temp_low_max_val != temp_low_min_val) {
          if (rack.minTemperature == temp_low_max_val) {
            $svg_temp_low.css('display', 'inherit');
            $svg_temp_low.css('fill', '#378bd1');
          } else if (rack.minTemperature == temp_low_min_val) {
            $svg_temp_low.css('display', 'inherit');
            $svg_temp_low.css('fill', '#99536e');
          }else{
            $svg_temp_low.css('display','none');
          }
        }

      });
    },

    setRackImage(data) {
      data.map(rack => {
      if(rack.soc > 100){
        rack.soc = 100;
      }

      let percent = rack.soc / 100;
      let barheight = 75 * percent;
      let positiony = 375;

      let $rack_scale_red = this.$fig.find(`#rack-scale-red-${rack.rackNo}`);
      let $rack_scale_yellow = this.$fig.find(`#rack-scale-yellow-${rack.rackNo}`);
      let $rack_scale_green = this.$fig.find(`#rack-scale-green-${rack.rackNo}`);
      let $rack_scale_error = this.$fig.find(`#rack-scale-error-${rack.rackNo}`);

      if(rack.alarm !== '00000000') {
        $rack_scale_error.css('display', 'inherit');
        $rack_scale_error.css('height', barheight);
        $rack_scale_error.attr('y',positiony + 95 - barheight);
        $rack_scale_red.css('display', 'none');
        $rack_scale_yellow.css('display', 'none');
        $rack_scale_green.css('display', 'none');
      } else {
        if (percent <= 0.2) {
          $rack_scale_red.css('display', 'inherit');
          $rack_scale_red.css('height', barheight);
          $rack_scale_red.attr('y', positiony + 95 - barheight);
          $rack_scale_yellow.css('display', 'none');
          $rack_scale_green.css('display', 'none');
          $rack_scale_error.css('display', 'none');
        } else if (percent <= 0.5) {
          $rack_scale_red.css('display', 'none');
          $rack_scale_yellow.css('display', 'inherit');
          $rack_scale_yellow.css('height', barheight);
          $rack_scale_yellow.attr('y', positiony + 95 - barheight);
          $rack_scale_green.css('display', 'none');
          $rack_scale_error.css('display', 'none');
        } else {
          $rack_scale_red.css('display', 'none');
          $rack_scale_yellow.css('display', 'none');
          $rack_scale_green.css('display', 'inherit');
          $rack_scale_green.css('height', barheight);
          $rack_scale_green.attr('y', positiony + 95 - barheight);
          $rack_scale_error.css('display', 'none');
        }
      }
    });
    },

    setRachErrorCode(data) {

      data.map(rack => {
        const alarm = Array.from(rack.alarm).reverse();
        alarm.map((error, index) => {
          let $error_f_val = null;
          let $error_txt = null;
          switch (index) {
            case 0: // OVP
              $error_f_val = this.$fig.find(`#rack-bg-ovp-f-${rack.rackNo}`);
              $error_txt = this.$fig.find(`#rack-txt-ovp-${rack.rackNo}`);
              break;
            case 1: // UVP
              $error_f_val = this.$fig.find(`#rack-bg-uvp-f-${rack.rackNo}`);
              $error_txt = this.$fig.find(`#rack-txt-uvp-${rack.rackNo}`);
              break;
            case 2: // OCP
              $error_f_val = this.$fig.find(`#rack-bg-ocp-f-${rack.rackNo}`);
              $error_txt = this.$fig.find(`#rack-txt-ocp-${rack.rackNo}`);
              break;
            case 3: // UCP
              $error_f_val = this.$fig.find(`#rack-bg-ucp-f-${rack.rackNo}`);
              $error_txt = this.$fig.find(`#rack-txt-ucp-${rack.rackNo}`);
              break;
            case 4: // OTP
              $error_f_val = this.$fig.find(`#rack-bg-otp-f-${rack.rackNo}`);
              $error_txt = this.$fig.find(`#rack-txt-otp-${rack.rackNo}`);
              break;
            case 5: // UTP
              $error_f_val = this.$fig.find(`#rack-bg-utp-f-${rack.rackNo}`);
              $error_txt = this.$fig.find(`#rack-txt-utp-${rack.rackNo}`);
              break;
          }

          if (error === "1") {
            if ($error_f_val) {
              $error_f_val.css('display', 'inherit');
              $error_f_val.css('fill', '#ff3121');
              $error_txt.css('fill', '#ffffff');
            }
          } else {
            if ($error_f_val) {
              $error_f_val.css('display', 'none');
              $error_txt.css('fill', '#727272');
            }
          }
        });
      });
    },

    setAnimationPCS(data) {
      //PCSのswithの表示と電流の流れ
      let $base_switch_off_val = this.$fig.find('#base-switch-off');
      let $base_switch_on_val = this.$fig.find('#base-switch-on');
      let $base_switch_neutral = this.$fig.find('#base-switch-neutral');
      if (data[0].switchOnOffBank == 1) {
        $base_switch_on_val.css('display', 'inline');
        let $pcs_path = this.$fig.find('#pcs-path');
        $pcs_path.attr("d", "M1800,125 L1800,215 " + (this.x_array[this.x_array.length - 1] + 190) + ",215");
        $base_switch_off_val.css('display', 'none');
        $base_switch_neutral.css('display', 'none');
        if (data[0].totalCurrentBank > 0) {
          let $base_switch_anime = $base_switch_on_val.find('animateMotion');
          $base_switch_anime.attr('keyPoints', '1;0');
          $base_switch_anime.attr('keyTimes', '0;1');
          $base_switch_anime.attr('calcMode', 'linear');
        } else if (data[0].totalCurrentBank == 0) {
          $base_switch_on_val.css('display', 'none');
          $base_switch_off_val.css('display', 'none');
          $base_switch_neutral.css('display', 'inline');
        } else if (data[0].totalCurrentBank < 0) {
          let $base_switch_anime = $base_switch_on_val.find('animateMotion');
          $base_switch_anime.attr('keyPoints', '0;1');
          $base_switch_anime.attr('keyTimes', '0;1');
          $base_switch_anime.attr('calcMode', 'linear');
        }
      } else {
        $base_switch_on_val.css('display', 'none');
        $base_switch_off_val.css('display', 'inline');
        $base_switch_neutral.css('display', 'none');
      }
    },

    setAnimationRack(data) {
      var rackCount = data[0].rackCount;
      data.map((rack, index) => {
        let $yoko = this.$fig.find(`#current-yoko-${rack.rackNo}`);
        let $yoko_path = this.$fig.find(`#current-yoko-${rack.rackNo}-path`);

        //電流アニメの左座標
        let path_x1 = parseFloat(this.x_array[index]) + 190;  //「parseInt」から「parseFloat」へ変更
        //電流アニメの右座標
        let path_x2 = parseFloat(this.x_array[index + 1]) + 190;  //「parseInt」から「parseFloat」へ変更

        if (index < rackCount -1) {
          var yoko_current_sum = 0;
          for (var i = 0; i < rackCount && i < (index + 1); i++) {
            if((this.rack_switch_array_1[i] != 0 && this.rack_switch_array_2[i] != 0) && data[i].totalCurrent != null){
              yoko_current_sum += parseFloat(data[i].totalCurrent);  //「parseInt」から「parseFloat」へ変更
            }
          }

          $yoko_path.attr("d", "M" + path_x1 + ",215 L" + path_x2 + ",215");

          if (yoko_current_sum > 0) {
            $yoko.css('display', 'inherit');
            let $yoko_animate = $yoko.find('animateMotion');
            $yoko_animate.attr('keyPoints','0;1');
            $yoko_animate.attr('keyTimes', '0;1');
            $yoko_animate.attr('calcMode', 'linear');
          } else if (yoko_current_sum < 0) {
            $yoko.css('display', 'inherit');
            let $yoko_animate = $yoko.find('animateMotion');
            $yoko_animate.attr('keyPoints', '1;0');
            $yoko_animate.attr('keyTimes', '0;1');
            $yoko_animate.attr('calcMode', 'linear');
          } else {
            $yoko.css('display', 'none');
          }
        } else {
          $yoko.css('display', 'none');
        }
      });
    }
  }
};
</script>

<style>
.dashboard2 {
  z-index: 9;
}

.dashboard2 .offset-sm3 {
  margin: 0 !important;
  flex-basis: 100% !important;
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/router/Customer/RackStatus.vue